import { inspectionModes, watchVariants } from "@/demos/explore/config";
import type { DemoAction, DemoControlState, DemoId } from "@/demos/types";

/** The per-demo control cluster drawn inside wireframe frames 5, 6 and 7. */
export function DemoControls({
  id,
  controls,
  dispatch,
}: {
  id: DemoId;
  controls: DemoControlState;
  dispatch: (action: DemoAction) => void;
}) {
  if (id === "see") {
    return (
      <div className="demo-controls compact-controls" data-ui-control data-testid="see-controls">
        {(["none", "laptop", "phone"] as const).map((value) => (
          <button
            key={value}
            type="button"
            className={controls.seeFocus === value ? "active" : ""}
            aria-pressed={controls.seeFocus === value}
            onClick={() => dispatch({ type: "see-focus", value })}
          >
            {value === "none" ? "Overview" : value}
          </button>
        ))}
      </div>
    );
  }

  if (id === "explore") {
    return (
      <div className="demo-controls configurator-panel" data-ui-control data-testid="explore-controls">
        <div className="control-row">
          <span>Materials</span>
          {watchVariants.map((variant) => (
            <button
              key={variant.id}
              type="button"
              className={`swatch ${controls.exploreVariant === variant.id ? "active" : ""}`}
              style={{ background: variant.color }}
              // Colour alone must never carry the state, hence the label + pressed.
              aria-label={`${variant.label} finish`}
              aria-pressed={controls.exploreVariant === variant.id}
              title={variant.label}
              onClick={() => dispatch({ type: "explore-variant", value: variant.id })}
            />
          ))}
        </div>
        <div className="control-row segmented" aria-label="Inspection mode">
          <span>View</span>
          {inspectionModes.map((mode) => (
            <button
              key={mode.id}
              type="button"
              className={controls.exploreInspection === mode.id ? "active" : ""}
              aria-pressed={controls.exploreInspection === mode.id}
              onClick={() => dispatch({ type: "explore-inspection", value: mode.id })}
            >
              {mode.label}
            </button>
          ))}
        </div>
        <p className="control-readout" aria-live="polite">
          Case: {watchVariants.find((variant) => variant.id === controls.exploreVariant)?.label}
        </p>
      </div>
    );
  }

  return (
    <div className="demo-controls compact-controls" data-ui-control data-testid="engage-controls">
      {/* <button
        type="button"
        aria-pressed={controls.engageSide === "back"}
        data-testid="engage-flip"
        onClick={() => dispatch({ type: "engage-side", value: controls.engageSide === "front" ? "back" : "front" })}
      >
        {controls.engageSide === "front" ? "Tap to flip" : "Show front"}
      </button> */}
      {/* {(["bursts", "rainbow", "swirl"] as const).map((style) => (
        <button
          key={style}
          type="button"
          className={controls.engageHoloStyle === style ? "active" : ""}
          aria-pressed={controls.engageHoloStyle === style}
          onClick={() => dispatch({ type: "engage-holo-style", value: style })}
        >
          {style}
        </button>
      ))} */}
    </div>
  );
}
